<template>
    <base-form
            :unique-id="uniqueId"
            :is-modal-form="isModalForm"
            :form-title="formTitle"
            :form-sub-title="formSubTitle"
            :submit-title="submitTitle"
            :fields="fields"
            :on-submit="onSubmit"
            :form-price="formPrice"
    ></base-form>
</template>

<script>
    import {emailTest, phoneTest} from "../regex";
    import {baseFormMixin} from "../mixins";

    export default {
        mixins: [baseFormMixin],
        computed: {
            fields() {
                return {
                    name: {
                        type: 'text',
                        placeholder: 'Представьтесь, пожалуйста',
                        required: false,
                        messages: {
                            empty: 'Представьтесь, пожалуйста',
                            invalid: 'Представьтесь, пожалуйста',
                        },
                    },
                    email: {
                        type: 'text',
                        placeholder: 'Ваш E-mail',
                        required: false,
                        messages: {
                            empty: 'Введите ваш E-mail',
                            invalid: 'Укажите корректный E-mail',
                        },
                        validation: value => emailTest.test(value)
                    },
                    phone: {
                        type: 'phone',
                        placeholder: 'Ваш телефон',
                        required: true,
                        messages: {
                            empty: 'Введите ваш номер телефона',
                            invalid: 'Укажите корректный номер телефона',
                        },
                        validation: value => phoneTest.test(value)
                    }
                }
            }
        },

        methods: {
            onSubmit(values) {
                return axios.post('/create_lead', {...values, ...{formName: 'Запрос на консультацию с сайта bx24asterisk.ru', formTitle: this.formTitle}});
            }
        },
    }
</script>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/components/RequestForm.vue